import z from "zod";
import i18next from "i18next";
import { useQuery } from "react-query";

import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { publicApiCall } from "src/api/axiosClient/userApi";
import { SSO_PROTOCOLS } from "src/pages/Authentication/ssoConnector";

export const SSO_CONNECTORS_ENDPOINT = "/api/auth/sso-connectors" as const;

const SsoConnectorZodSchema = z.object({
    protocol: z.enum(SSO_PROTOCOLS),
    providerName: z.string(),
    label: z.string().min(1),
});

export type ApiSsoConnector = z.infer<typeof SsoConnectorZodSchema>;

export const ssoConnectorsCacheKey = "ssoConnectors" as const;

export const useSsoConnectors = () => {
    const query = useQuery({
        queryKey: [ssoConnectorsCacheKey, i18next.resolvedLanguage],
        queryFn: async () => {
            const response = await publicApiCall.get(SSO_CONNECTORS_ENDPOINT, {
                headers: { "Accept-Language": i18next.resolvedLanguage ?? "en" },
            });

            return response.data["hydra:member"] ?? [];
        },
        select: (members: unknown[]) =>
            zodParseWithDetailedLog(members, SsoConnectorZodSchema.array(), {
                operation: "GET",
                endpoint: SSO_CONNECTORS_ENDPOINT,
            }),
        onError: (error) => {
            console.error("Failed to fetch SSO connectors:", error);
        },
    });

    return {
        connectors: query.data ?? [],
        isLoading: query.isLoading,
    };
};
